import {AnyAction} from "redux";
import {LoadingState} from "./index";
import {RequestOptions} from "../types/Types";

/**
 * Provide a way to store all loading events in one place
 * Example: https://medium.com/stashaway-engineering/react-redux-tips-better-way-to-handle-loading-flags-in-your-reducers-afda42a804c6
 *
 * @param {LoadingState} state
 * @param {AnyAction} action
 * @returns {LoadingState}
 */

const loading = (state: LoadingState = {}, action: AnyAction) => {
  const {type} = action;
  const options: RequestOptions = action.options;

  const typeMatches = (/(.*)_(BEGIN|SUCCESS|FAILURE)/).exec(type);
  if (!typeMatches) {
    return state;
  }

  const shouldShowLoader = options && !options.hideLoader;

  const [, requestName, requestState] = typeMatches;

  return {
    ...state,
    [requestName]: {
      showLoader: requestState === "BEGIN" && shouldShowLoader
    }
  };
};

export default loading;
